
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mental-health",
      function () {
        return require("private-next-pages/mental-health/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mental-health"])
      });
    }
  